import type { PropsWithChildren } from "react";

import { useLocation } from "react-router";

import { StaticRouteNavigate } from "@/modules/static-route";
import { useAuthContext } from "@/services/auth";

export const AuthRouteGate = ({ children }: PropsWithChildren) => {
  const { hasToken } = useAuthContext();
  const location = useLocation();

  // If token is defined send user to Dashboard
  if (hasToken) {
    return <StaticRouteNavigate route="dashboard" state={{ from: location }} />;
  }

  // Otherwise render auth routes
  return children;
};
